/*
 * Created on Tue Jun 15 2021
 *
 * Copyright (c) 2021 Khor Chai Hong
 */

import React from 'react';
import preloader from "../assets/images/preloaders/01-preloader-10px-000000.gif";

export default function Loader({ otherLoader }) {
  return (
    <div className="loader">
      <img src={!otherLoader ? preloader : otherLoader} alt="preloader" />
    </div>
  );
}
